<template>
    <div v-if="requestPanel == 'prompt'" class="m-3">
        <div class="part-request-form">
            <div class="d-flex flex-column align-items-center justify-content-center">
                <img src="../../assets/images/placeholders/UL-Loading-Done.gif">
                <h2>
                    Part Request
                </h2>
                <div class="text-center pb-2">
                    Let us know which models you would like for this part and we'll do our best to make sure this never happens again.
                </div>
                <div class="font-weight-bold">
                    Manufacturer: {{content.mfr}}
                </div>
                <div class="font-weight-bold">
                    Manufacturer PN: {{content.pn}}
                </div>
                <div v-show="loggedIn == true">
                    <a class="btn btn-sm btn-light m-2" href @click.prevent="submitRequest">Submit</a>
                </div>
                <div v-show="loggedIn == false">
                    <a class="btn btn-sm btn-light m-2" href @click.prevent="signIn">Sign In to Request</a>
                </div>
            </div>
        </div>
    </div>
    <div v-if="requestPanel == 'submitted'" class="m-3">
        <div class="d-flex flex-column align-items-center justify-content-center">
            <img src="../../assets/images/placeholders/UL-Loading-Done.gif">
            <h2>
                Request Received
            </h2>
            <div class="text-center pb-2">
                Thanks for your feedback. This part has been added to the queue
            </div>
            <div class="font-weight-bold">
                Manufacturer: {{content.mfr}}
            </div>
            <div class="font-weight-bold">
                Manufacturer PN: {{content.pn}}
            </div>
            <div class="text-center pb-2">
                Need this expedited? <a target="_blank" href="https://www.ultralibrarian.com/contact">Contact Us</a> to learn more about our custom part build services
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import partApiClient from '@/services/apiServices/partApiClient.js'

    export default {
        name: 'RequestPanel',
        props: {
            content: {
                type: Object,
                default: () => {
                    return {
                        mfr: "",
                        pn: "",
                        puid: "",
                        euid: ""
                    }
                }
            }
        },
        computed: {
            ...mapGetters('oidcStore', [
                'oidcIsAuthenticated'
            ]),
            loggedIn: function () {
                return this.oidcIsAuthenticated
            }
        },
        data() {
            return {
                requestPanel: "prompt"
            }
        },
        methods: {
            ...mapActions('oidcStore', [
                'authenticateOidc'
            ]),
            signIn: function () {
                var configContent = JSON.parse(process.env.VUE_APP_OIDC_OPTIONS);
                var localOptions = {
                    extraQueryParams: {
                        "Base-Url": configContent.baseurl + this.$route.params.instance,
                        "App-Type": configContent.apptype,
                        "Custom-View": configContent.customView
                    }
                };
                this.authenticateOidc({ redirectPath: this.$route.path, options: localOptions });
            },
            submitRequest: function () {
                this.requestPanel = 'submitted';
                var partRequest = {
                    partUniqueId: this.content.puid,
                    externalId: this.content.euid,
                    manufacturerName: this.content.mfr,
                    manufacturerPartNumber: this.content.pn,
                };
                partApiClient.SubmitPartRequest(partRequest).catch(() => {
                    this.$store.commit('SET_GLOBAL_ERROR', 'Part Request Submission Connection Failed');
                });
            }
        }
    }
</script>

<style scoped>
</style>